module.exports = __webpack_public_path__ + "static/media/logo193.991f855f.png";